import { isFulfilled } from '@reduxjs/toolkit'
import { FieldArray, FormikHelpers } from 'formik'
import React, { FC } from 'react'

import Form from '../../components/Form'
import CustomButton from '../../components/UI/Buttons/CustomButton'
import TextInput from '../../components/UI/Inputs/TextInput'

import { useDispatch } from '../../store'
import { inviteToProjectThunk } from '../../store/project/thunks'

interface CreateProjectStep2Props {
  goForward: () => void
  skipCreation?: () => void
  inProgress: boolean
  project_id: any
}

const CreateProjectStep2: FC<CreateProjectStep2Props> = ({
  inProgress,
  project_id,
  goForward,
  ...props
}) => {
  const dispatch = useDispatch()
  const setUpForm = {
    initialValues: {
      invite_to_project: [{ name: '', email: '', project_role: 'external-approver' }]
    },
    validation: 'invite_members',
    validateOnBlur: false,
    onSubmit: async (values: any, actions: FormikHelpers<any>) => {
      const inviteRequests = values.invite_to_project.map((member: any) =>
        dispatch(inviteToProjectThunk({ ...member, project_id }))
      )
      const inviteResponses = await Promise.all(inviteRequests)
      // TODO check all invitations
      if (isFulfilled(inviteResponses[0] as any)) {
        goForward()
      }
    }
  }

  return (
    <div className='agency-creation-step project-creation step-2'>
      <div className='agency-creation-step__title'>Invite client</div>
      <div className='agency-creation-step__description'>
        Add your clients here. They will only be able to review content.
      </div>
      <Form {...setUpForm}>
        <div className='agency-creation-step__invite-rows'>
          <FieldArray
            name='invite_to_project'
            render={({ push, form: { values, ...formRest }, ...rest }) => (
              <>
                {values.invite_to_project &&
                  values.invite_to_project.map((user: any, index: number) => (
                    <div key={index} className='agency-creation-step__invite-row'>
                      <TextInput
                        label='Name'
                        name={`invite_to_project.${index}.name`}
                        placeholder='Name'
                      />
                      <TextInput
                        label='Email'
                        name={`invite_to_project.${index}.email`}
                        placeholder='Email'
                      />
                    </div>
                  ))}
              </>
            )}
          />
        </div>

        <div className='agency-creation-step__buttons'>
          <CustomButton button='primary' size='big' type='button' onClick={() => goForward()}>
            Skip for now
          </CustomButton>
          <CustomButton inProgress={inProgress} button='primary' size='big' type='submit'>
            Submit
          </CustomButton>
        </div>
      </Form>
    </div>
  )
}

export default CreateProjectStep2
